import { useLocation, useRoutes, Navigate } from "react-router-dom";
import { Login } from "../Components/Login";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import { OnBoarding } from "../Components/OnBoarding";
import { TeamAnalizer } from "../Components/TeamAnalizer";
import { VerificationPhoneNumber } from "../Components/VerificationPhoneNumber";
import HandleAuth from "../Components/HandleAuth";
import FAQs from "../Components/FAQs/FAQs";
import { UserDetails } from "../Components/UserDetails/UserDetails";
import { isMobile } from "react-device-detect";
import ChatbotPaywall from "../Components/ChatbotPaywall/ChatbotPaywall";
import { Capacitor } from "@capacitor/core";
import TradeAnalyzer from "../Components/TradeAnalyzer/TradeAnalyzer";
import SitStartDecider from "../Components/SitStartDecider/SitStartDecider";
import { PlatformSelector } from "../Components/PlatformSelector/PlatformSelector";
import { LeagueSync } from "../Components/LeagueSync/LeagueSync";
import Oauth2 from "../Components/Yahoo/oauth";
import LeagueHubMyTeam from "../Components/LeagueHubTeam/LeagueHubTeam";
import Congratulations from "../Components/Congratulations/Congratulations";
import { AiChatbot } from "../Components/Chatbot/AiChatbot";
import { useState, useEffect } from "react";
import Toolbox from "../Components/Toolbox/Toolbox";
import TopBottomLayout from "./TopBottomLayout";
import News from "../Components/News/News";
import useDeepLink from "../Context/DeepLinkContext/DeepLinkContext";
import EarlyBirdPaywall from "../Components/ChatbotPaywallRevenuecat/EarlyBirdPaywall";
import ShareScreen from "../Components/ShareScreen/ShareScreen";
import LoadingScreen from "./LoadingScreen";
import AnimatedPage from "./AnimatedPage";
import SyncLeague from "../Components/LeagueSync/SyncLeague/SyncLeague";
import TradeAnalyzeReportScreen from "../Components/TradeAnalyzers/TradeAnalyzeReportScreen";
import ChatbotWrapper from "./ChatbotWrapper";
import Onboardings from "../Components/Onboardings/Onboardings";
import BoardingSurveyWrapper from "./BoardingSurveyWrapper";

export const AppRoutes = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  useDeepLink();
  const bottomRoutes = ["/chatbot-ai", "/news", "/toolbox"];
  const newRoutes = [
    "/chatbot-paywall-v2",
    "/welcome",
    "/verify-phone-number",
    "/user-details",
    "/share-screen",
    "/on-boarding",
  ];

  const routes = useRoutes([
    {
      path: "/",
      element: <HandleAuth />,
    },
    {
      path: "/user-details",
      element: (
        <PrivateRoute>
          <AnimatedPage>
            <UserDetails />
          </AnimatedPage>
        </PrivateRoute>
      ),
    },
    {
      path: "/on-boarding",
      element: (
        <PrivateRoute>
          <Onboardings />
        </PrivateRoute>
      ),
    },
    {
      path: "/welcome",
      element: Capacitor.isNativePlatform() ? (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ) : (
        <Login />
      ),
    },
    {
      path: "/verify-phone-number",
      element: (
        <PublicRoute>
          <VerificationPhoneNumber />
        </PublicRoute>
      ),
    },
    {
      path: "/FAQs",
      element: (
        <PrivateRoute>
          <FAQs />
        </PrivateRoute>
      ),
    },
    {
      path: "/chatbot-paywall",
      element: (
        <PrivateRoute>
          <ChatbotPaywall />
        </PrivateRoute>
      ),
    },
    {
      path: "/platform-selector",
      element: (
        <PrivateRoute>
          <PlatformSelector />
        </PrivateRoute>
      ),
    },
    {
      path: "/trade-analyzer",
      element: (
        <PrivateRoute>
          <TradeAnalyzer />
        </PrivateRoute>
      ),
    },
    {
      path: "/league-sync/:FantasyType",
      element: (
        <PrivateRoute>
          <LeagueSync />
        </PrivateRoute>
      ),
    },
    {
      path: "/sit-start-decider",
      element: (
        <PrivateRoute>
          <SitStartDecider />
        </PrivateRoute>
      ),
    },
    {
      path: "/Yahoo",
      element: (
        <PrivateRoute>
          <Oauth2 />
        </PrivateRoute>
      ),
    },
    {
      path: "/my-team-league-sync",
      element: (
        <PrivateRoute>
          <LeagueHubMyTeam />
        </PrivateRoute>
      ),
    },
    {
      path: "/congratulations",
      element: (
        <PrivateRoute>
          <Congratulations />
        </PrivateRoute>
      ),
    },
    {
      path: "/chatbot-ai",
      element: (
        <PrivateRoute>
          <BoardingSurveyWrapper>
            <ChatbotWrapper>
              <AiChatbot />
            </ChatbotWrapper>
          </BoardingSurveyWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: "/news",
      element: (
        <PrivateRoute>
          <News />
        </PrivateRoute>
      ),
    },
    {
      path: "/toolbox",
      element: (
        <PrivateRoute>
          <TopBottomLayout>
            <Toolbox />
          </TopBottomLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/chatbot-paywall-v2",
      element: (
        <PrivateRoute>
          <EarlyBirdPaywall />
        </PrivateRoute>
      ),
    },
    {
      path: "/share-screen",
      element: (
        <PrivateRoute>
          <ShareScreen />
        </PrivateRoute>
      ),
    },
    {
      path: "/sync-league",
      element: (
        <PrivateRoute>
          <SyncLeague />
        </PrivateRoute>
      ),
    },
    {
      path: "/trade-analyze-report",
      element: (
        <PrivateRoute>
          <TradeAnalyzeReportScreen />
        </PrivateRoute>
      ),
    },
  ]);

  useEffect(() => {
    // Set loading false after a small delay to ensure routes are processed
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  console.log("routes", routes);
  console.log(location.pathname);

  const routesWithOutAnimation = [""];

  const matchPath = (path: any, pattern: any) => {
    const regex = new RegExp(`^${pattern.replace(/:\w+/g, "\\w+")}$`);
    console.log(
      `Matching path: ${path} with pattern: ${pattern} as regex: ${regex}`,
    );
    return regex.test(path);
  };

  const currentPath = location.pathname;

  console.log(`Current path: ${currentPath}`);

  const shouldAnimate = !routesWithOutAnimation.some((pattern) =>
    matchPath(currentPath, pattern),
  );

  return (
    <>
      {isLoading ? (
        <LoadingScreen />
      ) : bottomRoutes?.includes(currentPath) ? (
        routes
      ) : newRoutes?.includes(currentPath) ? (
        <div className="w-full h-full bg-[#000513]">{routes}</div>
      ) : (
        <div
          style={{
            background: `#000513 no-repeat center center / cover`,
            boxSizing: "border-box",
            width: "100vw",
            height: "100svh",
            overflowY: "auto",
          }}
          className="no-select"
        >
          <div className="page w-full bg-[#000513]">{routes}</div>
        </div>
      )}
    </>
  );
};
